import React from 'react';
import { useParams } from 'react-router';
import useCanvasZoom from 'components/canvas/hooks/use-canvas-zoom';
import {
  FitToScreenIcon,
  MinusIcon,
  PlusIcon,
  Row,
  Separator,
  StyledZoomMenu,
  ZoomPercentage,
} from './style';

function MiniMapMenu() {
  const { id } = useParams();

  const {
    zoomIn,
    zoomOut,
    zoomTo100,
    zoomToFitAll,
    zoomToPercentage,
  } = useCanvasZoom(id as string);

  // This is used just to rerender component since useStage(inside useCanvasZoom) is not reactive anymore due to performance issues
  const [_, setRenderedAt] = React.useState(new Date().toISOString());

  function withRerender(callback) {
    return function () {
      callback();
      setRenderedAt(new Date().toISOString());
    };
  }

  return (
    <StyledZoomMenu>
      <Row spaceBetweeen>
        <FitToScreenIcon onClick={withRerender(zoomToFitAll)} />
        <Separator />
        <PlusIcon onClick={withRerender(zoomIn)} />
        <MinusIcon onClick={withRerender(zoomOut)} />
        <ZoomPercentage onClick={withRerender(zoomTo100)}>
          {zoomToPercentage()}
        </ZoomPercentage>
      </Row>
    </StyledZoomMenu>
  );
}

export default MiniMapMenu;
